import client from './client'

const apiBasePath = '/api/admin/account/changegroup/'

export default {
  search: entryForm => client.post(apiBasePath + 'search', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm)
}
